export default __webpack_public_path__ + "static/media/client32.7250ac9c.png";